import React from 'react';
import cookie from 'react-cookie';
import { Button, ListGroup, ListGroupItem } from 'react-bootstrap';
import SvgIcon from 'components/SvgIcon/SvgIcon';
import styles from './BriefDetailsHowItWorks.module.scss';

export default function BriefDetailsHowItWorks() {
  return (
    <ListGroup className={styles.container}>
      <ListGroupItem style={{ border: 0 }}>
        <div style={{ padding: '10px 5px' }}>
          <h2 className={styles.heading}>How It Works</h2>
          <hr />
          <div className={styles.item}>
            <div className={styles.itemImage}>🔍</div>
            <div className={styles.itemCopy}>
              <p className={styles.subHeading}>
                <strong>Get quality leads</strong>
              </p>
              <p>
                Review job leads for free, filter by local or global clients,
                and get real time notifications for new opportunities.
              </p>
            </div>
          </div>
          <hr />
          <div className={styles.item}>
            <div className={styles.itemImage}>🎉</div>
            <div className={styles.itemCopy}>
              <p className={styles.subHeading}>
                <strong>Apply with ease</strong>
              </p>
              <p>
                Pick the best leads, unlock contact details, and apply
                effortlessly with Twine's AI application tools.
              </p>
            </div>
          </div>
          <hr />
          <div className={styles.item}>
            <div className={styles.itemImage}>📈</div>
            <div className={styles.itemCopy}>
              <p className={styles.subHeading}>
                <strong>Grow your career</strong>
              </p>
              <p>
                Showcase your work, pitch to the best leads, land new clients
                and use Twine’s tools to find more opportunities.
              </p>
            </div>
          </div>
          <div className={styles.signUpLink}>
            <Button
              bsStyle="primary"
              bsSize="lg"
              href="/signup?type=seller"
              className={styles.signUpButton}
              onClick={() => {
                const expires = new Date();
                // set to expire in 5 minutes
                expires.setTime(expires.getTime() + 5 * 60 * 1000);

                cookie.save('brief-link', window.location.pathname, {
                  path: '/',
                  expires,
                });
              }}
            >
              <strong>Sign up for free</strong>{' '}
              <SvgIcon icon="chevron-right" size="16" />
            </Button>
          </div>
        </div>
      </ListGroupItem>
    </ListGroup>
  );
}
